import { observable, makeObservable, action, computed } from 'mobx'

import {
   ActionConfigInterface,
   BaseNavItem,
   UnionNavItemModel
} from '../../../types'

class BaseNavItemModel {
   readonly id!: string
   readonly actionsConfig!: ActionConfigInterface | null
   readonly slug!: string | null

   private _parent!: UnionNavItemModel | null
   private _name!: string
   private _iconId!: string | null
   private _isOpen!: boolean
   private _count!: number | null

   constructor(navItem: BaseNavItem) {
      this.id = navItem.id
      this._name = navItem.name
      this._iconId = navItem.iconId ?? null
      this.actionsConfig = navItem.actionsConfig ?? null
      this._parent = navItem.parent ?? null
      this._isOpen = navItem.isOpen ?? false
      this.slug = navItem.slug ?? null
      this._count = navItem.count ?? null

      makeObservable<
         BaseNavItemModel,
         '_name' | '_iconId' | '_isOpen' | '_parent' | '_count'
      >(this, {
         _name: observable,
         _iconId: observable,
         _isOpen: observable,
         _parent: observable,
         _count: observable,

         name: computed,
         iconId: computed,
         isOpen: computed,
         parent: computed,
         count: computed,

         setName: action.bound,
         setIconId: action.bound,
         setIsOpen: action.bound,
         setParent: action.bound,
         setCount: action.bound
      })
   }

   get name(): string {
      return this._name
   }

   get iconId(): string | null {
      return this._iconId
   }

   get isOpen(): boolean {
      return this._isOpen
   }

   get parent(): UnionNavItemModel | null {
      return this._parent
   }

   get count(): number | null {
      return this._count
   }

   setName(name: string): void {
      this._name = name
   }

   setIconId(iconId: string | null): void {
      this._iconId = iconId
   }

   setIsOpen(isOpen: boolean): void {
      this._isOpen = isOpen
   }

   setParent(parent: UnionNavItemModel | null): void {
      this._parent = parent
   }

   setCount(count: number | null): void {
      this._count = count
   }
}

export default BaseNavItemModel
